<ng-container *ngIf="myRequestData">
  <nb-accordion multi class="request-accordion">
    <nb-accordion-item class="request-list-container" [expanded]="expanded">
      <nb-accordion-item-header>
        <div class="request-list" fxLayout="row">
          <div class="request-title">
            <span>Attendance</span>
            <span style="margin-left: 4px;">({{ myRequestData?.attendanceDates?.length }})</span>
          </div>
        </div>
      </nb-accordion-item-header>

      <nb-accordion-item-body class="body-container">
        Attendance regularization requests pending with IS:
        <span class="isName">{{ myRequestData?.isName }}</span>

        <table>
          <tr>
            <th>Date</th>
          </tr>
          <tr *ngFor="let item of myRequestData.attendanceDates">
            <td>{{ item }}</td>
          </tr>
        </table>
      </nb-accordion-item-body>
    </nb-accordion-item>
  </nb-accordion>
  <div class="notify-section">
             <div class="training-panel" role="region" aria-label="ISMS & DP Training" *ngIf="!(hasActiveISMS && hasActiveDataPrivacy)">
                <div class="ismsInfoIcon">
                  <a [routerLink]="'feed-details/143'" (click)="cancelClicked()"><img src="/assets/images/approvals/Info.svg" alt="img" /></a>
                  
                </div>
                <div class="panel-header">
                  <h3 class="panel-title">ISMS and DP Training Status</h3>
                </div>

                <div class="cards-flex">
                  <div class="cards-row">
                    <div class="mini-card">
                      <div class="card-top card-top--blue">ISMS</div>

                      <div class="card-body">
                        <span class="status">
                          <span class="dot">
                            <img class="dot-icon"
                              [src]="hasActiveISMS ? 'assets/images/complete.svg' : 'assets/images/error.svg'"
                              [alt]="hasActiveISMS ? 'Completed' : 'Pending'" />
                          </span>

                          {{ hasActiveISMS ? 'Completed' : 'Pending' }}
                        </span>
                      </div>
                    </div>
                    <div class="mini-card">
                      <div class="card-top card-top--blue">DP</div>
                      <div class="card-body">
                        <span class="status">
                          <span class="dot">
                            <img class="dot-icon"
                              [src]="hasActiveDataPrivacy ? 'assets/images/complete.svg' : 'assets/images/error.svg'"
                              [alt]="hasActiveDataPrivacy ? 'Completed' : 'Pending'" />
                          </span>
                      {{ hasActiveDataPrivacy ? 'Completed' : 'Pending' }}
                        </span>
                      </div>
                    </div>
                 </div>
                </div>

                <div class="wide-card">
                  <div class="title">Overall Status</div>
                  <p><b>{{completedCount}}</b> out of 2 completed <a class="quiz-link"
                      href='https://performancemanager10.successfactors.com/sf/learning?destUrl=https%3a%2f%2flttechnolo%2eplateau%2ecom%2flearning%2fuser%2fdeeplink%5fredirect%2ejsp%3flinkId%3dPROGRAM%5fDETAILS%26programID%3dISMS%2band%2bData%2bPrivacy%2b2025%2d26%26fromSF%3dY&company=LTTS'
                      target='_blank'>Click here</a> to access and complete it.</p>
                </div>
              </div>
              <div class="quizInfoSection" *ngIf="hasActiveQuiz && showQuizNotify">
                <div class="quizInfoIcon">
                  <img src="/assets/images/approvals/Info.svg" alt="img" />
                </div>
                <div class="title">
                  InQuizitive
                </div>
                <div class="notify-text">
                  <p>You have a pending quiz. <a  class="quiz-link" (click)="navigateToUrl('/quiz')">Click here</a> to access and complete it.</p>
                </div>
              </div>
              <div class="quizInfoSection" *ngIf="talentAIData">
                <div class="quizInfoIcon">
                  <img src="/assets/images/approvals/Info.svg" alt="img" />
                </div>
                <div class="title">
                  Talent AI
                </div>
                <div class="notify-text">
                  <p>Talent AI is Now Live. <a class="quiz-link" [routerLink]="'/talentai'" (click)="cancelClicked()">Click here </a> to access and update your skills. </p>
                </div>
              </div>
              <div class="townhallInfoSection" *ngIf="hasActiveTownhall && showTownhallNotify">
                <div class="townhallInfoIcon">
                  <img src="/assets/images/approvals/Info.svg" alt="img" />
                </div>
                <div class="title">
                  Town Hall
                </div>
                <div class="notify-text">
                  <p>We're excited to announce our townhall <a [routerLink]="'/townhall'" class="townhall-link" (click)="cancelClicked()">Click here</a> to share your questions and help shape the conversation</p>
                </div>
              </div>
              <div class="infoSection">
                <div class="infoIcon">
                  <img src="/assets/images/approvals/Info.svg" alt="img" />
                </div>
                <div class="reminder-text">
                  <span style="color:#000000;font-weight:bold;font-size:15px">Available Reminders</span>
                  <ol>
                    <li>Project Expiry</li>
                    <li>Visa Expiry</li>
                  </ol>
                </div>
                <span class="approvalText">Available Approvals</span>
                <ol class="list-of-approvals">
                  <!-- <li>Accommodation</li> -->
                  <li>Attendance</li>
                  <!-- <li>Cab</li> -->
                  <li>Leave</li>
                  <li>Synergy</li>
                  <li>Forex</li>
                </ol>
              </div>
              </div>
</ng-container>
